import ErrorWrapper from './error-wrapper';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LinkOutlined from '@mui/icons-material/LinkOutlined';

export default function InvalidSecondaryDomainPage() {
  return (
    <ErrorWrapper>
      <Card variant="outlined" sx={{ maxWidth: 920, zIndex: 2, px: 4, py: 6 }}>
        <CardHeader title={'Secondary Domain Error'} />
        <CardContent>
          <Stack flexDirection="row" gap={1} alignItems="center">
            <Typography>
              You are logged into a secondary domain that has not been enabled
              in gPanel.
            </Typography>
            <IconButton
              size="small"
              component="a"
              href="https://resources.promevo.com/knowledgebase/gpanel/administration/secondary-domains"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkOutlined />
            </IconButton>
          </Stack>
        </CardContent>
      </Card>
    </ErrorWrapper>
  );
}
